var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    style: {
      position: 'fixed',
      inset: '0',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      zIndex: String(_vm.zIndex),
      pointerEvents: 'none'
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('div', {
    style: _vm.maskStyle(0, 0, _vm.vw, Math.max(0, _vm.rect.top)),
    on: {
      "click": _vm.outsideClick
    }
  }), _c('div', {
    style: _vm.maskStyle(_vm.rect.top + _vm.rect.height, 0, _vm.vw, Math.max(0, _vm.vh - (_vm.rect.top + _vm.rect.height))),
    on: {
      "click": _vm.outsideClick
    }
  }), _c('div', {
    style: _vm.maskStyle(_vm.rect.top, 0, Math.max(0, _vm.rect.left), _vm.rect.height),
    on: {
      "click": _vm.outsideClick
    }
  }), _c('div', {
    style: _vm.maskStyle(_vm.rect.top, _vm.rect.left + _vm.rect.width, Math.max(0, _vm.vw - (_vm.rect.left + _vm.rect.width)), _vm.rect.height),
    on: {
      "click": _vm.outsideClick
    }
  }), _c('div', {
    style: {
      position: 'fixed',
      top: _vm.rect.top + 'px',
      left: _vm.rect.left + 'px',
      width: _vm.rect.width + 'px',
      height: _vm.rect.height + 'px',
      borderRadius: _vm.radius + 'px',
      boxShadow: '0 0 0 1px rgba(255,255,255,0.9), 0 0 24px 8px rgba(0,0,0,0.25)',
      pointerEvents: 'none',
      transition: 'top .08s, left .08s, width .08s, height .08s'
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }